export class TokenService {
  private static token: string | null = null;

  static setToken(newToken: string) {
    this.token = newToken;
  }

  static getToken() {
    return this.token;
  }

  static clearToken() {
    this.token = null;
  }
}
